import React, { useState } from 'react';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';

export default function Range() {
    // Initialize state with the start value fixed at 0
    const [value, setValue] = useState([0, 75]);

    // Handle change event to only update the second value
    const handleChange = (newValue) => {
        setValue([0, newValue[1]]); // Fix the first value at 0, update only the second
    };

    return (
        <div>
            <RangeSlider
                value={value}
                min={0}
                max={100}
                step={1}
                onInput={handleChange}
                thumbsDisabled={[true, false]} // Keep the first thumb disabled
            />
            {/* <p>Value: {value[0]} - {value[1]}</p> */}
        </div>
    );
}
